import { AppProps } from 'next/app';
import Script from 'next/script';
import { I18nextProvider } from 'react-i18next';
import i18n from '../lib/i18n';
import '../styles/globals.css';
import PostHogProvider from '../components/PostHogProvider';
import ErrorBoundary from '../components/ErrorBoundary';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <PostHogProvider>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <Component {...pageProps} />
        </ErrorBoundary>
      </I18nextProvider>

      {/* Third-party scripts loaded after hydration using Next.js Script component */}
      
      {/* Google Tag Manager */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PXCB84S9');
          `,
        }}
      />

      {/* Global error handler for third-party script errors */}
      <Script
        id="error-handler"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.addEventListener('error', function(e) {
              if (e.message && (
                e.message.includes('SCDynimacBridge') || 
                e.message.includes("Can't find variable: SC")
              )) {
                e.preventDefault();
                return false;
              }
            });
          `,
        }}
      />
    </PostHogProvider>
  );
}

export default MyApp;
